document.addEventListener('DOMContentLoaded', function () {
  /* ---- Mobile nav ---- */
  var burger = document.querySelector('.site-header__burger');
  var nav    = document.querySelector('.mobile-nav');
  var close  = document.querySelector('.mobile-nav__close');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.add('open'); document.body.style.overflow = 'hidden'; });
  }
  if (close && nav) {
    close.addEventListener('click', function () { nav.classList.remove('open'); document.body.style.overflow = ''; });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('click', function () {
      var a = item.querySelector('.faq-a'), arr = item.querySelector('.faq-arrow');
      var open = a && a.classList.contains('open');
      document.querySelectorAll('.faq-a').forEach(function (x) { x.classList.remove('open'); });
      document.querySelectorAll('.faq-arrow').forEach(function (x) { x.classList.remove('open'); });
      if (!open && a) { a.classList.add('open'); if (arr) arr.classList.add('open'); }
    });
  });

  /* ---- Qty selector ---- */
  document.querySelectorAll('.qty-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var sel = opt.closest('.qty-selector');
      if (sel) sel.querySelectorAll('.qty-opt').forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
    });
  });

  /* ---- Product thumb switcher ---- */
  document.querySelectorAll('.prod-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var group = thumb.closest('.prod-thumbs');
      if (group) group.querySelectorAll('.prod-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var src = thumb.querySelector('img') && thumb.querySelector('img').src;
      var main = document.getElementById('prod-main-img');
      if (src && main) main.src = src;
    });
  });

  /* ---- Header shadow on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 2px 20px rgba(26,35,50,0.08)' : '';
    }, { passive: true });
  }
});
